import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    root: {
      width: "63.6%",
      height: "100%",
      margin: "auto"
    },
    mainPanel: {
      width: 350,
      background: "transparent",
      marginBottom: "9rem",
      marginTop: "9rem"
    },
    headTextLogo: {
      margin: "0",
      display: "flex",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      paddingRight: 29.5,
      paddingLeft: 0,
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 29.5
    },
    menuItem: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      marignRight: 20.67,
      borderRadius: 4,
      // marginBottom: 16,
      cursor: "pointer",
      transition: "background 0.2s ease",
      "& svg": {
        minWidth: "20px"
      },
      minWidth: "52px"
    },
    itemButton: {
      width: "100%",
      height: "100%",
      padding: "22px 30px",
      justifyContent: "flex-start",
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      "&:hover": {
        background: "#006E80"
      },
      borderRadius: 8
    },
    menuLabel: {
      marginLeft: 15,
      color: "#FFFFFF",
      transition: "all 0.2s ease"
      // whiteSpace: "",
      // overflow: "hidden",
      // textOverflow: "ellipsis"
    },
    paperMenu: {
      padding: "0px",
      borderRadius: "8px",
      boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.18)"
    },
    parentMenu: {
      padding: "8px 0px",
      borderRadius: "8px"
    },
    childrenMenu: {
      padding: "5px 12px 5px 12px",
      fontFamily: "ScgFont",
      justifyContent: "flex-start !important",
      "&:hover": {
        background: "#F4F7FE !important",
        color: "#007E92 !important",
        "& .MuiTypography-body1": {
          color: "#007E92 !important"
        }
      },
      minHeight: "34px",
      fontSize: "16px !important",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "4px"
    },
    chipClass: {
      bottom: "80%",
      right: "-18px"
    }
  }),
  { name: "HomePage" }
);

export default useStyles;
